import React from "react";
import { Link } from "react-router-dom";
const AuthTemplate = (props) => {
  return (
    <div>
      <div className='d-flex justify-content-center mt-5 mb-2 p-2'>
        <div className='card' style={{ minWidth: "35%" }}>
          <div className='card-body'> {props.children}</div>
        </div>
      </div>
      <div className='text-center mb-5'>
        <Link to='/' className='text-muted'>
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default AuthTemplate;
